import { EventTypes, HISTORY_ACTION_MODE } from '@candulabs/craft';
import React from 'react';

import { DuplicateButton } from 'craft/containers/FloatingMenu/commons/DuplicateButton';
import { InsertMode, useEditor, useMutations, useSelection } from 'craft/hooks';

export const DuplicateTooltipButton = ({
  nodeId,
  tooltipPlacement,
}: {
  nodeId: string;
  tooltipPlacement: 'top' | 'bottom';
}) => {
  const { actions } = useEditor();
  const { getSerializedTree } = useSelection();
  const { insertSerializedNodeTrees } = useMutations();

  const onDuplicate = () => {
    const clonedTree = getSerializedTree(nodeId);

    // remove duplicated placement id
    delete clonedTree.nodes[clonedTree.rootNodeId].props?.placementId;

    const newTree = insertSerializedNodeTrees([clonedTree], nodeId, InsertMode.NEXT_TO);
    actions.setNodeEvent(EventTypes.selected, newTree[0].rootNodeId, HISTORY_ACTION_MODE.MERGE);
  };

  return <DuplicateButton onClick={onDuplicate} tooltipPlacement={tooltipPlacement} />;
};
